import { Schedule, ScheduleBlock } from "../../data/entities";
import { ScheduleRepo, ScheduleODataRepo } from "../../data/repo";
import { BaseEntityService } from "../BaseEntityService"

export class ScheduleService extends BaseEntityService<Schedule, ScheduleRepo, ScheduleODataRepo> {
  constructor(){
    super(new ScheduleRepo(), new ScheduleODataRepo());
  }

  async getDefaultSchedulesAsync(providerId: number): Promise<Schedule[]> {
    return this.repo.getDefaultSchedulesAsync(providerId);
  }

  async getExceptionSchedulesAsync(providerId: number): Promise<Schedule[]> {
    return this.repo.getExceptionSchedulesAsync(providerId);
  }

  async setScheduleBlocksAsync(scheduleId: number, scheduleBlocks: ScheduleBlock[]): Promise<void> {
    return this.repo.setScheduleBlocksAsync(scheduleId, scheduleBlocks);
  }

  async cloneAsync(id: number, effectiveDate: Date): Promise<number> {
    return this.repo.cloneAsync(id, effectiveDate);
  }

  async createScheduleAsync(schedule: Schedule): Promise<Schedule> {
    return this.repo.createScheduleAsync(schedule);
  }

  async deleteScheduleAsync(scheduleId: number): Promise<void> {
    return this.repo.deleteScheduleAsync(scheduleId)!;
  }
  
  async getUserSchedulesAsync(userId: number): Promise<Schedule[]> {
    return await this.repo.getUserSchedulesAsync(userId);
  }

  async getSchedulesByProviderIdsAsync(providerIds: number[]): Promise<Schedule[]> {
    const ids = providerIds.join(",");
    return await this.repo.getSchedulesByProviderIdsAsync(ids);
  }
 
}

export default ScheduleService;
